import * as React from 'react';
import {Trans} from "react-i18next";
import i18n from "i18next";

export const termsOfUseTitle = "Terms of use";

const TermsOfUseBody = (props) => {
  const isEnglishTranslation = i18n.language === "en";

  return (
    <>
      <div>
        <Trans
          i18nKey="termsOfUse.defaultTerms"
          components={isEnglishTranslation ? {
            termsOfUseLink: <a target="_blank" rel="noopener noreferrer" href={props.termsOfUseLink} aria-label="Oracle.com Terms of Use">Oracle.com Terms of Use</a>,
            privacyLink: <a target="_blank" rel="noopener noreferrer" href={props.privacyPolicyLink} aria-label="Oracle Privacy Policy">Oracle Privacy Policy</a>
          } : undefined}
        >By clicking on the “Continue” button below, you understand and agree that the use of Oracle's web site
          is subject to the <a target="_blank" rel="noopener noreferrer" href={props.termsOfUseLink}> Oracle.com Terms of Use</a>. Additional
          details regarding Oracle's collection and use of your personal information, including information about access,
          retention, rectification, deletion, security, cross-border transfers and other topics, is available in the
          <a target="_blank" rel="noopener noreferrer" href={props.privacyPolicyLink}> Oracle Privacy Policy</a>.
        </Trans>
      </div>
    </>
  );
}
export default TermsOfUseBody;
